import React, { useState, lazy, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { TCurrentBlock, TInput, TParams, TAllData, TAnswers } from './types';
import Header from '../components/Header';
import * as api from './api';
import LoadingSpinner from '../components/LoadingSpinner';
import Welcome from '../pages/Welcome';
import Chapter from '../components/Chapter';
import Snack from '../components/Snack';
const Navigation = lazy(() => import('../components/Navigation'));
import Recommendations from '../pages/Recommendations';

export interface RoutingProps {
    currentBlock: TCurrentBlock[]
    livshistorieId: string
    linkTilPensionsInfo: any
    baseUrl: string
    pensionsAlder: number
    resultatLink: string
    Overskrift: string
    firmaTelefon: string
    email: string
    telefon: string
    salary: string
    samtykke: boolean
	samtykkeLabel: string
	samtykkeTekst: string
    erMedlem: boolean
    tilmeldtAarligtServicetjek: boolean
    velkomstEpiserverId: string
	pdfTitle: string
}

const Routing = (propsData: RoutingProps) => {

	const { baseUrl, pensionsAlder, resultatLink, firmaTelefon, email, telefon, samtykke, salary, erMedlem, tilmeldtAarligtServicetjek, velkomstEpiserverId } = propsData;
	const [data, setData] = useState<TAllData>();
	const [navParams, setNavParams] = useState<TParams>({ chapterTitle: '', chapterId: '0', isChapter: true, isSnack: false, prev: '0', variant: 'down' });
	const [inputData, setInputData] = useState<TInput>({ email: email, telephone: telefon, consent: samtykke, salary: salary, signedUp: tilmeldtAarligtServicetjek });
	const [isLoading, setIsLoading] = useState(true);
	const history = useHistory();
	const [touchStartX, setTouchStartX] = useState<number>(0);
	const [touchEndX, setTouchEndX] = useState<number>(0);
	const distanceX = touchStartX - touchEndX;
	const minSwipeDistance = 150;
	const [answers, setAnswers] = useState<TAnswers[]>([]);
	const objdata:{[key:string]: string} = {};

	const onTouchStart = (e: React.TouchEvent) => {
		setTouchEndX(0);
		setTouchStartX(e.targetTouches[0].clientX);
	};

	const onTouchMove = (e: React.TouchEvent) => setTouchEndX(e.targetTouches[0].clientX);

	const onTouchEnd = () => {
		if (!touchStartX || !touchEndX) {
			return;
		}

		const rightSwipe = distanceX < -minSwipeDistance;

		if (rightSwipe && navParams.prev) {
			setNavParams({ ...navParams, variant: 'up' });
			history.push(navParams.prev);
		}
	};

	propsData.currentBlock.forEach((e: { name: string, value: string }) => {
		const { name, value } = e;
		objdata[name] = value;
	});

	useEffect(() => {
		fetchChapters();
	}, []);

	const fetchChapters = async () => {
		setIsLoading(true);
		const servicetype = (objdata['ServicetjekType']);
		const data = await api.getData(servicetype);
		setData(data);
		setIsLoading(false);
	};

	const recommendationTextData = {
		'BookingUrl': objdata['BookingUrl'],
		'formTitle': objdata['AastTitle'],
		'formText': objdata['AastText'],
		'formSubmittedText': objdata['AastFooterText'],
		'title': objdata['Overskrift'],
		'persondataLabel': objdata['PersondataLabel'],
		'velkomstEpiserverId': velkomstEpiserverId
	};

	if (isLoading) {
		return (
			<main className="lhp-main">
				<LoadingSpinner />
			</main>
		);
	}

	const welcomeProps = { propsData, inputData, setInputData };
	const recommendationProps = { resultatLink, baseUrl, recommendationTextData, erMedlem, pensionsAlder, phnNumber: firmaTelefon, fullData: data, inputData, objdata, setInputData };

	return (
		<>
			<Header title={ objdata['Overskrift'] } baseUrl={ baseUrl } />
			<Navigation
				setNavParams={ setNavParams }
				navParams={ navParams }
				allData={ data }
			/>
			<main onTouchStart={ onTouchStart } onTouchMove={ onTouchMove } onTouchEnd={ onTouchEnd } className="lhp-main">
				<Switch>
					<Route exact path="/"><Welcome { ...welcomeProps } /> </Route>

					<Route exact path="/kapitel/:chapterId">
						<Chapter
							setNavParams={ setNavParams }
							setAnswers={ setAnswers }
							navParams={ navParams }
							answers={ answers }
							erMedlem={ erMedlem }
							resultUrl={ resultatLink }
							allData={ data }
							y2answer={ false }
							servicetype={ objdata['ServicetjekType'] }
						/>

					</Route>

					<Route exact path="/kapitel/:chapterId/side/:pageId">
						<Chapter
							setNavParams={ setNavParams }
							setAnswers={ setAnswers }
							navParams={ navParams }
							answers={ answers }
							resultUrl={ resultatLink }
							allData={ data }
							y2answer={ false }
							servicetype={ objdata['ServicetjekType'] }
						/>
					</Route>

					<Route exact path="/kapitel/:chapterId/snack" >
						<Snack
							setNavParams={ setNavParams }
							navParams={ navParams }
							answers={ answers }
							btnText={ 'Næste' }
							allData={ data }
							servicetype={ 'Velkomst' }
							resultUrl={ resultatLink }
							pensionsAlder={ pensionsAlder }
						/>

					</Route>

					<Route exact path="/kapitel/:chapterId/side/:pageId/snack" >
						<Snack
							setNavParams={ setNavParams }
							navParams={ navParams }
							answers={ answers }
							btnText={ 'Næste' }
							allData={ data }
							servicetype={ 'Velkomst' }
							resultUrl={ resultatLink }
							pensionsAlder={ pensionsAlder }
						/>

					</Route>
					<Route exact path="/anbefalinger" ><Recommendations { ...recommendationProps } /></Route>
				</Switch>
			</main>
			<div id="portal" />
		</>
	);
};

export default Routing;